// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (max-width: 991px) {
    .events_area {
        padding: 70px 0;
    }
}
.events_area .event-link {
    color: #4dce62;
    font-size: 13px;
    text-transform: uppercase;
}
.events_area .event-link img {
    margin-left: 5px;
    display: inline-block;
}
.single_event {
    margin-bottom: 30px;
}
.single_event .event_thumb {
    overflow: hidden;
}
.single_event .event_thumb img {
    transition: all 0.3s ease 0s;

}
.single_event .event_details {
    background: #234F1E;
    position: absolute;
    top: 0px;
    right: 0px;
    width: 300px;
    padding: 15px 25px;
    color: #ffffff;
    opacity: 0.8;
}
.single_event .event_details .date {
    color: #ffffff;
    padding-right: 15px;
    border-right: 2px solid #fff;
    font-family: "Rubik", sans-serif;
    font-size: 14px;
}
.single_event .event_details .date span {
    display: block;
    color: #4dce62;
    font-size: 28px;
    font-weight: 500;
}
.single_event .event_details .time-location {
    padding-left: 15px;
    font-size: 14px;
}
.single_event .event_details .time-location p {
    margin-bottom: 0px;
}
.single_event .event_details .time-location p span {
    color: #ffffff;
    font-size: 13px;
    font-weight: 500;
}
.single_event:hover img {
    transform: scale(1.1);
}
.single_event:hover h4 a {
    color: #4dce62;
}
`, "",{"version":3,"sources":["webpack://./src/assets/css/events.css"],"names":[],"mappings":"AAAA;IACI;QACI,eAAe;IACnB;AACJ;AACA;IACI,cAAc;IACd,eAAe;IACf,yBAAyB;AAC7B;AACA;IACI,gBAAgB;IAChB,qBAAqB;AACzB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,gBAAgB;AACpB;AACA;IAII,4BAA4B;;AAEhC;AACA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,YAAY;IACZ,kBAAkB;IAClB,cAAc;IACd,YAAY;AAChB;AACA;IACI,cAAc;IACd,mBAAmB;IACnB,4BAA4B;IAC5B,gCAAgC;IAChC,eAAe;AACnB;AACA;IACI,cAAc;IACd,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,kBAAkB;IAClB,eAAe;AACnB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,qBAAqB;AACzB;AACA;IACI,cAAc;AAClB","sourcesContent":["@media (max-width: 991px) {\n    .events_area {\n        padding: 70px 0;\n    }\n}\n.events_area .event-link {\n    color: #4dce62;\n    font-size: 13px;\n    text-transform: uppercase;\n}\n.events_area .event-link img {\n    margin-left: 5px;\n    display: inline-block;\n}\n.single_event {\n    margin-bottom: 30px;\n}\n.single_event .event_thumb {\n    overflow: hidden;\n}\n.single_event .event_thumb img {\n    -webkit-transition: all 0.3s ease 0s;\n    -moz-transition: all 0.3s ease 0s;\n    -o-transition: all 0.3s ease 0s;\n    transition: all 0.3s ease 0s;\n\n}\n.single_event .event_details {\n    background: #234F1E;\n    position: absolute;\n    top: 0px;\n    right: 0px;\n    width: 300px;\n    padding: 15px 25px;\n    color: #ffffff;\n    opacity: 0.8;\n}\n.single_event .event_details .date {\n    color: #ffffff;\n    padding-right: 15px;\n    border-right: 2px solid #fff;\n    font-family: \"Rubik\", sans-serif;\n    font-size: 14px;\n}\n.single_event .event_details .date span {\n    display: block;\n    color: #4dce62;\n    font-size: 28px;\n    font-weight: 500;\n}\n.single_event .event_details .time-location {\n    padding-left: 15px;\n    font-size: 14px;\n}\n.single_event .event_details .time-location p {\n    margin-bottom: 0px;\n}\n.single_event .event_details .time-location p span {\n    color: #ffffff;\n    font-size: 13px;\n    font-weight: 500;\n}\n.single_event:hover img {\n    transform: scale(1.1);\n}\n.single_event:hover h4 a {\n    color: #4dce62;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
